import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Bootstrap_Modal_Service_Config {
  modal_header_html: string;
  modal_body_html: string;
  modal_color_variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'default';
}
@Injectable({
  providedIn: 'root'
})

export class Bootstrap_Modal_Service {

  private modalSubject = new BehaviorSubject<Bootstrap_Modal_Service_Config | null>(null);

  modal$ = this.modalSubject.asObservable();

  open(config: Bootstrap_Modal_Service_Config) {
    this.modalSubject.next(config);
  }

  close() {
    this.modalSubject.next(null);
  }
}
